import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeDangerVariantClasses = "border-transparent bg-danger-muted text-danger";

const badgeVariants = cva(
  "inline-flex items-center  border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-muted text-foreground",
        destructive: badgeDangerVariantClasses,
        outline: "text-foreground",
        warning: "border-transparent bg-warning-muted text-warning",
        success: "border-transparent bg-success-muted text-success",
        info: "border-transparent bg-info-muted text-info",
        danger: badgeDangerVariantClasses,
      },
      size: {
        default:
          "text-ui-label px-2.5 py-1 rounded-full [&_svg]:size-3.5 [&_svg]:shrink-0 [&_svg]:mr-1.5",
        sm: "text-ui-eyebrow px-2 py-0.75 rounded-full",
        chip: "text-ui-body-xs px-2 py-0.5 rounded-md [&_svg]:size-3 [&_svg]:shrink-0 [&_svg]:mr-1.5",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, size, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant, size }), className)} {...props} />;
  },
);
Badge.displayName = "Badge";

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
